var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOggyHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29409",
    "data-name": "Group 29409",
    transform: "translate(-8 -422.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(8 422.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29408",
    "data-name": "Group 29408",
    transform: "translate(24 426.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50207",
    "data-name": "Path 50207",
    d: "M6.574,16.714a.251.251,0,0,0,.039-.424,3.657,3.657,0,0,0-3.34-.906A5.369,5.369,0,0,1,6.307,16.69.248.248,0,0,0,6.574,16.714Z",
    transform: "translate(-3.273 -8.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50208",
    "data-name": "Path 50208",
    d: "M6.623,20.118a.252.252,0,0,0-.187-.383,3.332,3.332,0,0,0-2.752.711,5.24,5.24,0,0,1,2.7-.212A.245.245,0,0,0,6.623,20.118Z",
    transform: "translate(-3.477 -11.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50209",
    "data-name": "Path 50209",
    d: "M10.661,27.713c3.016-7.539-1.005-10.555-1.005-10.555s-4.524-2.513-3.518-4.524,3.518-1.005,6.032,0c4.021-9.047,8.545-5.026,6.534-.5,8.042-2.011,6.534,2.011,3.518,5.529s1.005,10.053,1.005,10.053Z",
    transform: "translate(-4.626 -4.875)",
    fill: "#7bbed5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50210",
    "data-name": "Path 50210",
    d: "M29.27,2.564,27.5,5.122a1.751,1.751,0,0,0-.967-.21l.652-2.219L25.364,5.311c-.085.05-.168.09-.255.15a1.141,1.141,0,0,1,.215.824c1.091-.738,2.807-.529,1.668,4.155a6.12,6.12,0,0,1,1.219-.62,4.325,4.325,0,0,0,0-4.042Z",
    transform: "translate(-14.134 -2.564)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50211",
    "data-name": "Path 50211",
    d: "M12.1,22.192l0-.011c5.251,1.239,8.782-.249,10.82-1.715,1.058-.76.94-1.4.661-1.723l.736-.685c2.325,2.461-3.568,5.591-8.438,5.591a14.87,14.87,0,0,1-2.36-.175A3.626,3.626,0,0,0,12.1,22.192Z",
    transform: "translate(-7.664 -10.271)",
    fill: "#70276e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_471",
    "data-name": "Ellipse 471",
    cx: 1.794,
    cy: 1.282,
    rx: 1.794,
    ry: 1.282,
    transform: "matrix(0.384, -0.923, 0.923, 0.384, 7.069, 7.091)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 1.103,
    cy: 0.788,
    rx: 1.103,
    ry: 0.788,
    transform: "matrix(0.272, -0.962, 0.962, 0.272, 7.391, 6.653)",
    fill: "#64dd17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 0.479,
    cy: 0.404,
    rx: 0.479,
    ry: 0.404,
    transform: "translate(7.595 5.805) rotate(-67.387)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50212",
    "data-name": "Path 50212",
    d: "M20.983,13.331a4.747,4.747,0,0,0-.621-.634,3.344,3.344,0,0,0-1.539-.727c.4-.85,1.188-1.326,1.814-1.066a1.594,1.594,0,0,1,.491,2.135A2.322,2.322,0,0,1,20.983,13.331Z",
    transform: "translate(-11.008 -6.677)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_474",
    "data-name": "Ellipse 474",
    cx: 1.888,
    cy: 1.349,
    rx: 1.888,
    ry: 1.349,
    transform: "translate(8.584 7.693) rotate(-65.28)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_475",
    "data-name": "Ellipse 475",
    cx: 1.103,
    cy: 0.788,
    rx: 1.103,
    ry: 0.788,
    transform: "translate(8.923 7.005) rotate(-67.387)",
    fill: "#64dd17"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_476",
    "data-name": "Ellipse 476",
    cx: 0.479,
    cy: 0.409,
    rx: 0.479,
    ry: 0.409,
    transform: "translate(9.173 6.431) rotate(-67.387)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50213",
    "data-name": "Path 50213",
    d: "M24.382,14.337a3.047,3.047,0,0,0-2.538-1.2c.015-.037.025-.073.041-.11.457-.992,1.4-1.532,2.11-1.205a1.768,1.768,0,0,1,.456,2.387C24.431,14.256,24.4,14.295,24.382,14.337Z",
    transform: "translate(-12.51 -7.123)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50214",
    "data-name": "Path 50214",
    d: "M30.692,23.85l.209,2.1-1.643-1.377A11.247,11.247,0,0,0,30.692,23.85Z",
    transform: "translate(-16.197 -13.151)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50215",
    "data-name": "Path 50215",
    d: "M17.125,27.023l-.594,1.793-.98-1.927A15.671,15.671,0,0,0,17.125,27.023Z",
    transform: "translate(-9.38 -14.663)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28954",
    "data-name": "Group 28954",
    transform: "translate(17.455 7.759)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_477",
    "data-name": "Ellipse 477",
    cx: 0.754,
    cy: 0.754,
    rx: 0.754,
    ry: 0.754,
    transform: "translate(1.005)",
    fill: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_478",
    "data-name": "Ellipse 478",
    cx: 0.754,
    cy: 0.754,
    rx: 0.754,
    ry: 0.754,
    transform: "translate(0 2.011)",
    fill: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50216",
    "data-name": "Path 50216",
    d: "M41.333,19.172a.251.251,0,0,1,.113-.41c1.45-.438,2.268-.3,2.942.329a3.9,3.9,0,0,0-2.8.152A.248.248,0,0,1,41.333,19.172Z",
    transform: "translate(-39.625 -18.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50217",
    "data-name": "Path 50217",
    d: "M39.338,23.156a.251.251,0,0,1,.212-.369,3.333,3.333,0,0,1,2.7.893,5.243,5.243,0,0,0-2.679-.391A.246.246,0,0,1,39.338,23.156Z",
    transform: "translate(-38.651 -20.379)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50218",
    "data-name": "Path 50218",
    d: "M15.665,16.128c-1.155-.65-2.647-1.2-3.537,0-.624.844.048,3.032,2.863,3.345,2.839.316,4.4-.963,4.211-2.118S16.822,16.778,15.665,16.128Z",
    transform: "translate(-7.571 -8.957)",
    fill: "#cd2616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOggyHighlighted);
export default __webpack_public_path__ + "static/media/oggyHighlighted.623d1358559f1206644e7e383b01024f.svg";
export { ForwardRef as ReactComponent };